import { useEffect, useState } from 'react'

import { useAppContext } from 'contexts/app-context/hooks'
import { isEmpty } from 'lodash'
import { makeTraceDetails } from 'common'
import { useScreenFinishLoadTac } from 'common/hooks/useScreenFinishLoadTac'
import { Routes } from 'common/constants'

import { TUseEntityTransactionReturn } from '../types'
import { ENTITY_TRANSACTION_DEFAULT_OBJ, ENTITY_TRANSACTION_DURATION_MS } from '../utils'

const useEntityTransaction = (): TUseEntityTransactionReturn => {
  const { userSelectedEntity, entityMenuContent, isAppLoading, isAppError, isAppActive } =
    useAppContext()

  const [isNavigateToHome, setIsNavigateToHome] = useState(false)

  const content =
    userSelectedEntity &&
    !isEmpty(entityMenuContent?.content?.entityTransactionSection) &&
    !isEmpty(entityMenuContent?.content?.entityTransactionSection[userSelectedEntity])
      ? entityMenuContent?.content?.entityTransactionSection[userSelectedEntity]
      : undefined

  const isError = isAppError || !content

  const isActive = isAppActive || !!entityMenuContent?.isActive

  useScreenFinishLoadTac({
    name: 'EntityTransaction',
    screen: Routes.ENTITY_TRANSACTION,
    action: 'EntityTransactionFinishLoad',
    entity: userSelectedEntity,
    shouldSend: !isAppLoading && !isError && isActive && !!content,
    logLabel: 'send entity transaction finish tac',
  })

  // transaction screen duration
  useEffect(() => {
    if (!isAppLoading && !isError && isActive) {
      setTimeout(() => {
        setIsNavigateToHome(true)
      }, ENTITY_TRANSACTION_DURATION_MS)
    }
  }, [isActive, isAppLoading, isError])

  if (isAppLoading) return { ...ENTITY_TRANSACTION_DEFAULT_OBJ, isLoading: true }

  if (isError || !isActive) {
    const traceDetails = makeTraceDetails(isActive, entityMenuContent)

    return {
      ...ENTITY_TRANSACTION_DEFAULT_OBJ,
      isLoading: false,
      isError: true,
      traceDetails,
    }
  }

  const { icon, title, details, footnote } = content

  return {
    isError: isAppError,
    isLoading: isAppLoading,
    isNavigateToHome,
    traceDetails: '',
    icon,
    title,
    details,
    footnote,
  }
}

export { useEntityTransaction }
